import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { AppColors, PRODUCT_NAME } from "src/app/core";
import { SwatchTextures } from "src/app/shared/components/swatch/swatch-textures";
import { Testimonial } from "./testimonial";
import { TestimonialConfig } from "./testimonial-config";

@Injectable({
  providedIn: "root",
})
export class TestimonialDisplayService {
  constructor() {}

  fetchLatest$(): Observable<Testimonial[]> {
    return of(this.configureTestimonials(this.getTestimonials()));
  }

  configureTestimonials(testimonials: Testimonial[]): TestimonialConfig[] {
    const textures = [SwatchTextures.Rose, SwatchTextures.Circle, SwatchTextures.Square, SwatchTextures.Triangle];
    const colors = [AppColors.AccentPeach, AppColors.LightBeige, AppColors.Blueberry, AppColors.Beige];
    const textureColors = [AppColors.Blueberry, AppColors.Brown, AppColors.DarkBlue, AppColors.LightBeige];
    const textureSvgViewBoxes = ["120 70 1300 1300", "90 300 1000 1000", "80 0 1300 1300", "50 0 1250 1250"];

    return testimonials.map((data, idx) => {
      const config = data as TestimonialConfig;

      config.color = colors[idx % 4];
      config.texture = textures[idx % 4];
      config.textureColor = textureColors[idx % 4];
      config.textureSvgViewBox = textureSvgViewBoxes[idx % 4];

      return config;
    });
  }

  private getTestimonials(): Testimonial[] {
    return [
      {
        company: "The Foundry",
        testimonial: `${PRODUCT_NAME} provides all of the technical details, without feeling overly technical. The user friendly experience allows us to show our clients exactly what their event will look like.`,
        handle: "@thefoundrylic",
      },
      {
        company: "Purl Collective",
        testimonial: `${PRODUCT_NAME} is the technology we had been looking for! With two massive, mostly raw venues, we needed reliable technology that could swiftly bring a creative vision to life and showcase how our spaces can transform.`,
        handle: "@purlcollective",
      },
      {
        company: "Something Different Party Rental",
        testimonial: `${PRODUCT_NAME} opens up new and creative ways to market our product. We think their flexibility and technical prowess are game changers and we’re thrilled to be a part of their ecosystem.`,
        handle: "@somethingdifferentpartyrental",
      },
      {
        company: "Florie Huppert Design",
        testimonial: `I love how dynamic, detailed and user friendly it is to work in the platform. The ${PRODUCT_NAME} team goes above and beyond to ensure venue details and measurements are accurate. This is a real game changer for me! I’m thrilled to have a tool I can trust!`,
        handle: "@floriehuppertdesign",
      },
      {
        company: "Bryant Park Grill",
        testimonial: `${PRODUCT_NAME} is an exceptional tool to help my clients both visualize their event and become a part of the floor plan design process. Everyone is blown away by how realistic the graphics are and the numerous customization options.`,
        handle: "@bryantparkgrill",
      },
      {
        company: "Loli Events",
        testimonial: `${PRODUCT_NAME} has been such a game changer for our business! As a wedding planner, my job is to make my clients' lives easier, design a beautiful event, and keep everything organized and I love that ${PRODUCT_NAME} has the same goals in mind!`,
        handle: "@lolievents",
      },
      {
        company: "AaB Creates",
        testimonial: `${PRODUCT_NAME} is an amazing platform that really puts design at the forefront, which will really help with communication with my clients! I am excited to use this platform moving forward for all of my events!`,
        handle: "@aabcreates",
      },
      {
        company: "Revelry Cooperative",
        testimonial: `As someone who works in raw spaces, it can sometimes be difficult for clients to imagine what their event might look like. I am so happy ${PRODUCT_NAME} has created a platform that is so simple and effective and is constantly updating based on feed back from those of us in the industry!`,
        handle: "@the_revelry_cooperative",
      },
    ];
  }
}
